import { Action } from '@ngrx/store';

import { Overview } from '../view-options/view-options.entity';

export enum SearchOptionsActionTypes {
    SetSelectedItemIds = '[SearchState] Set SelectedItemIds',
    Clear = '[SearchState] Clear SearchOptions'
}

export class SetSelectedItemIds implements Action {
    type: SearchOptionsActionTypes.SetSelectedItemIds = SearchOptionsActionTypes.SetSelectedItemIds;
    constructor(
        public view: Overview,
        public itemIds: string[]
    ) {}
}

export type SearchOptionsAction = SetSelectedItemIds;
